// extracted by mini-css-extract-plugin
module.exports = {"container":"Location_container__n5Grr","fat":"Location_fat__NUkWR","locationInfo":"Location_locationInfo__ENg8d","topLine":"Location_topLine__iMvdT"};